export function testId (vueInstance) {
  // Setting data attribute with a specific name
  vueInstance.directive('tid', {
    inserted: function (el, binding, vnode) {
      el.setAttribute('data-tid', binding.arg)
    }
  })
}
